import "./App.css";
import LandingPage from "./components/LandingPage";
import "./App.css";
import * as React from "react";
import VideoPage from "./components/VideoPage";
import { Route, Routes, Router} from "react-router-dom";
import UploadModel from "./components/UploadModel";


export const config = {
endpoint: `https://ee8dda16-9c5d-4ee7-81c1-cbcd5a61c457.mock.pstmn.io`,
};

const App = () => {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route exact path="/video/:videoId" element={<VideoPage />} />
      </Routes>
    </div>
  );
};
export default App;